import "./header-style.scss"
import {Link} from "react-router-dom";
import {useContext, useEffect, useState} from "react";
import axios from "axios";
import Aos from "aos";
import {MyContext} from "../App/App";

const Header = () => {
    let value = useContext(MyContext);
    const [contact, setContact] = useState("");

    useEffect(() => {
        axios.get(`${value.url}contact/`).then((response) => {
            setContact(response.data[0])
        });

        Aos.init({duration: 1000});
    }, []);

    return <div className="header-container">
        <Link to="/" className="logo seo-link">
            <img src="./images/logo.webp" alt="leader-auto-ship-logo"/>
        </Link>
        <div className="information-wrapper">
            <div className="info-box">
                <div className="icon-info">
                    <img src="./images/clock.webp" alt="working-time" loading="lazy"/>
                </div>
                <div className="text-information">
                    <div className="title">
                        <div>Monday - Friday: 6:00am -11:00pm EST</div>
                        <div>Weekends: 6:00am -11:00pm EST</div>
                    </div>
                </div>
            </div>
            <div className="info-box">
                <div className="icon-info">
                    <img src="./images/mail.webp" alt="gamil-company" loading="lazy"/>
                </div>
                <div className="text-information">
                    <div className="title">Email</div>
                    {contact.email}
                </div>
            </div>
            <div className="info-box">
                <div className="icon-info">
                    <img src="./images/telephone.webp" alt="phone" loading="lazy"/>
                </div>
                <div className="text-information">
                    <div className="title">
                        Call Us
                    </div>
                    (567) 666-4696
                </div>
            </div>
        </div>
    </div>
};

export default Header